import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useApplicantStore from '../../../store/applicantStore/useApplicantStore';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import { locator } from '../../../testing/e2e-locator/locator';

const ResidenceSection = () => {
  const { t } = useTranslation();
  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const {
    computed: {
      currentResidenceAddress,
      currentResidenceAmount,
      currentResidenceDuration,
      currentResidenceType,
    },
  } = useApplicantStore();

  return (
    <span data-testid={locator.components.residenceSection.root}>
      <div className="head">
        <h3 data-testid={locator.components.residenceSection.h3}>
          {t('ApplicantReviewPage.residence')}
        </h3>
        <Link
          data-testid={locator.components.residenceSection.editLink}
          to={`/applicant/${vehicleId}/edit-residence`}
        >
          {t('ApplicantReviewPage.edit')}
        </Link>
      </div>

      <ul>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.type')}</dt>
            <dd data-testid={locator.components.residenceSection.residenceType}>
              {currentResidenceType}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.address')}</dt>
            <dd data-testid={locator.components.residenceSection.address}>
              {currentResidenceAddress}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.amount')}</dt>
            <dd data-testid={locator.components.residenceSection.amount}>
              {currentResidenceAmount}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.duration')}</dt>
            <dd data-testid={locator.components.residenceSection.duration}>
              {currentResidenceDuration}
            </dd>
          </dl>
        </li>
      </ul>
    </span>
  );
};

export default ResidenceSection;
